<template>
  <div class="card red all-favorites" style="margin: 2rem;">
    <div class="form-title">
      <font-awesome-icon class="icon" :icon="['fas', 'heart']" />

      Mes plats préférés
    </div>

    <div style="display: flex;gap: 20px;flex-wrap: wrap;">
      <div v-for="dish of recipes" :key="dish.id" class="card liked-dish"
        :style="{ backgroundImage: 'url(' + mediaSrc(dish.photo) + ')' }" @click="gotoDish(dish)">
        <div class="overlay">
          <div class="liked-dish-name">{{ dish.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import { api } from "@/api";

export default {
  name: "AllMyLikedDishes",
  data() {
    return {
      recipes: [],
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      api.get(`my-liked-recipes/?all=true`)
        .then(response => {
          this.recipes = response.data;
        });
    },
    mediaSrc(uri) {
      return `${process.env.VUE_APP_BASE_URL}${uri}`;
    },
    gotoDish(dish) {
      this.$router.push({ name: "dish", params: { id: dish.id } });
    },
  },
};

</script>


<style scoped>
.liked-dish {
  position: relative;
  height: 150px;
  background-size: cover;
  background-position: center;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease;
  flex: 0 0 calc((100% - (3 * 20px)) / 4);
}

.liked-dish:hover {
  transform: scale(1.01);
}

.overlay {
  position: absolute;
  inset: 0;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s ease;
}

.liked-dish:hover .overlay {
  background-color: rgba(255, 255, 255, 0.7);
}

.liked-dish-name {
  font-size: 20px;
  font-weight: bold;
  color: #000;
  text-align: center;
  padding: 10px;
}
</style>
